var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDiscount = function SvgDiscount(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.6077 4.33922C29.1307 4.86222 29.1307 5.71016 28.6077 6.23317L6.23317 28.6078C5.71017 29.1307 4.86222 29.1307 4.33922 28.6078L3.39225 27.6608C2.86925 27.1377 2.86925 26.2898 3.39225 25.7667L25.7668 3.39225C26.2898 2.86925 27.1378 2.86925 27.6608 3.39225L28.6077 4.33922Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.97342 3.94702C7.38471 3.94702 5.28613 6.04559 5.28613 8.63431C5.28613 11.223 7.38471 13.3216 9.97342 13.3216C12.5621 13.3216 14.6607 11.223 14.6607 8.63431C14.6607 6.04559 12.5621 3.94702 9.97342 3.94702Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0264 18.6785C19.4377 18.6785 17.3391 20.777 17.3391 23.3658C17.3391 25.9545 19.4377 28.053 22.0264 28.053C24.6151 28.053 26.7137 25.9545 26.7137 23.3658C26.7137 20.777 24.6151 18.6785 22.0264 18.6785Z",
    fill: "currentColor"
  })));
};
export default SvgDiscount;